
import { watch } from 'vue';
import { widget } from '/public/charting_library';
import { STATE, i18n, WebSockets as Stream } from '@/Ship';
import { useChartActions } from '@chart';

const {
    onReady,
    getBars,
    resolveSymbol,
    subscribeBars,
    unsubscribeBars,
} = useChartActions();

export default class TradingView {

    static #instance = null;

    endpoint = 'klines';

    widget = null;

    config = {
        supports_marks: false,
        supports_timescale_marks: false,
        supports_time: true,
        supported_resolutions: [
            '1',  '5', '15', '30', '60', '1D', '1W',
        ],
    }

    options = {
        debug: false,
        symbol: STATE.SYMBOL,
        interval: 'D',
        container: 'tv_chart_container',
        library_path: '/charting_library/',
        locale: i18n.global.locale.value || 'en',
        disabled_features: ['use_localstorage_for_settings', 'popup_hints'],
        enabled_features: [],
        custom_css_url: '/tradingview.css',
        client_id: 'tipitek',
        user_id: 'public_user_id',
        fullscreen: false,
        autosize: true,
        theme: STATE.IS_LIGHT_MODE ? 'Light' : 'Dark',
        datafeedUrl: 'https://demo_feed.tradingview.com',
        charts_storage_api_version: '1.2',
        overrides: {
            //"paneProperties.background": "#131722",
            //"paneProperties.vertGridProperties.color": "#363c4e",
            //"paneProperties.horzGridProperties.color": "#363c4e",
            //"symbolWatermarkProperties.transparency": 90,
            //"scalesProperties.textColor" : "#AAA",
            //"mainSeriesProperties.candleStyle.wickUpColor": '#336854',
            //"mainSeriesProperties.candleStyle.wickDownColor": '#7f323f',
        },

        datafeed: {
            onReady,
            resolveSymbol,
            getBars,
            subscribeBars,
            unsubscribeBars,
        },
    };

    constructor() {

        TradingView.#instance = this;

        this.stream = Stream.getInstance(process.env.VUE_APP_WEBSOCKET);

        watch([
            () => STATE.SYMBOL,
            () => STATE.IS_LIGHT_MODE,
            i18n.global.locale
        ], () => {
            this.options.symbol = STATE.SYMBOL;
            this.options.theme = STATE.IS_LIGHT_MODE ? 'Light' : 'Dark';
            this.options.locale = i18n.global.locale.value;
            this.restartWidget();
        });

        return TradingView.#instance;
    }

    static getInstance() {

        return (!TradingView.#instance)
            ? new TradingView()
            : TradingView.#instance;
    }

    restartWidget() {
        this.removeWidget();
        this.createWidget();
    }

    createWidget() {
        this.widget = new widget(this.options);
    }

    removeWidget() {
        if (this.widget !== null) {
            this.widget.remove();
            this.widget = null;
        }
    }
}
